const $ = jQuery;

const Filter = {
  init: function () {
    const headerEl = document.querySelectorAll(".wpc-filter-header");

    headerEl.forEach((el) => {
      el.addEventListener("click", function () {
        const nextEl = el.nextElementSibling;

        headerEl.forEach((otherEl) => {
          if (otherEl !== el) {
            otherEl.nextElementSibling.classList.remove("active");
          }
        });

        nextEl.classList.toggle("active");
      });
    });
  },
};

export default Filter;
